/**
 * pr-custom.js — carrousels (galerie / avis / garanties) + sélection d'offre.
 * Vanilla, zéro dépendance. Port direct du comportement de
 * kenymarket-acv-gummies-REPLIQUE.html.
 */
(function () {
  "use strict";

  function initSliders() {
    document.querySelectorAll(".pr-slider-nav").forEach(function (nav) {
      var list = document.getElementById(nav.dataset.slider);
      if (!list) return;
      var cur = nav.querySelector(".js-cur");
      var tot = nav.querySelector(".js-tot");
      var items = list.children;
      if (tot) tot.textContent = items.length;

      function step() {
        var a = items[0].getBoundingClientRect();
        var b = items[1] ? items[1].getBoundingClientRect() : null;
        return b ? b.left - a.left : a.width;
      }
      function sync() {
        var s = step();
        var i = s ? Math.round(list.scrollLeft / s) : 0;
        if (cur) cur.textContent = Math.min(items.length, Math.max(1, i + 1));
        var prevBtn = nav.querySelector('[data-dir="-1"]');
        var nextBtn = nav.querySelector('[data-dir="1"]');
        if (prevBtn) prevBtn.disabled = list.scrollLeft < 4;
        if (nextBtn) nextBtn.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 4;
      }
      list.addEventListener("scroll", sync, { passive: true });
      nav.querySelectorAll(".pr-slider-nav__btn").forEach(function (b) {
        b.addEventListener("click", function () {
          list.scrollBy({ left: parseInt(b.dataset.dir, 10) * step(), behavior: "smooth" });
        });
      });
      sync();
      window.addEventListener("resize", sync);
    });
  }

  function initOfferSelection() {
    // Ecoute le "change" du vrai input radio, pas le "click" du label : ca
    // couvre le clic ET la navigation clavier native (fleches entre radios
    // du meme groupe, espace/entree) en un seul chemin, au lieu de dupliquer
    // la logique de selection clavier a la main.
    document.querySelectorAll(".pr-offer__radio").forEach(function (radio) {
      radio.addEventListener("change", function () {
        var el = radio.closest(".pr-offer");
        if (!el) return;
        var group = el.closest(".pr-offers");
        if (group) {
          group.querySelectorAll(".pr-offer").forEach(function (x) {
            x.classList.remove("pr-offer--selected");
          });
        }
        el.classList.add("pr-offer--selected");

        // Relaie la selection vers le widget COD (formulaire nom/telephone/
        // ville) embarque juste apres dans pr-hero : ce widget calcule le
        // prix/total reel a partir de son propre element data-offer="<id>"
        // (cache quand pr-hero affiche deja ses propres cartes d'offre) --
        // on simule un clic dessus pour que cod-widget.js le prenne en
        // compte exactement comme si le client avait clique dedans.
        var offerId = el.dataset.offer;
        if (!offerId) return;
        var info = el.closest(".pr-info");
        if (!info) return;
        var target = info.querySelector('.zc [data-offer="' + offerId + '"]');
        if (target) target.click();
      });
    });
  }

  // La barre "Order Now" collante ne doit jamais soumettre le formulaire --
  // elle ramene la cliente au formulaire et met le focus sur le premier
  // champ encore vide, comme un vrai raccourci de scroll, pas un submit.
  function initStickyFocus() {
    document.querySelectorAll("[data-zc-sticky-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var root = btn.closest("[data-zc]");
        if (!root) return;
        var form = root.querySelector("[data-zc-form]");
        if (!form) return;
        var firstEmpty = Array.prototype.find.call(
          form.querySelectorAll("input[name='fullName'], input[name='phone'], input[name='city']"),
          function (input) { return !input.value.trim(); }
        );
        (firstEmpty || form.querySelector("input")).focus({ preventScroll: true });
      });
    });
  }

  function init() {
    initSliders();
    initOfferSelection();
    initStickyFocus();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
